import { useEffect, useState } from "react";
import styled from "styled-components";
import useGlobal from "../../../../hooks/useGlobal";

import CSwiper from "./CSwiper";
// import Image from "../../../../components/Image";
import ListSwiper from "./ListSwiper";
import { Circle } from "@react-vant/icons";
import { useRef } from "react";
import usePersonSign from "../../../../hooks/usePersonSign";
const count = 2
export default function EquipCard() {
  const {
    userInfo,
    homeTabactive: active,
    setHomeTabactive: setActive,
  } = useGlobal();
  const [list, setList] = useState([]);
  const [leftList, setLeftList] = useState(new Array(count).fill({}));
  const swiperRef = useRef();
  const { sendShoesHandle } = usePersonSign();
  useEffect(() => {
    
    if (userInfo) {
      let newleftList = new Array(count).fill({})
      userInfo.equips.forEach((e) => {
        if (e.slot > -1 && e.slot < count) {
          newleftList[e.slot] = e ;
        }
      });
      newleftList = newleftList.filter(e =>!!e)

      setLeftList([...newleftList]);
      const l = userInfo.equips.filter(
        (e) => !e.is_bind && e.id !== newleftList[active].id && e.equip.remain_durability
      );
      if (newleftList[active].id) {
        l.unshift(newleftList[active]);
      }
      console.log('list',newleftList,userInfo,l)
      setList(l);
      swiperSlideToFrist()
    } else {
      setList([]);
      setLeftList(new Array(count).fill({}))
    }
  }, [active, userInfo]);

  const swiperSlideToFrist = () => {
    const swiper = swiperRef.current.getSwiper();
    if (swiper) {
      swiper.slideTo(0);
    }
  };

  return (
    <>
      <Wrapper>
        <Inner>
          <Left>
            <ListSwiper
              key={"left"}
              list={leftList}
              active={active}
              onClick={(index) => {
                setActive(index);
              }}
            />
          </Left>
          <Right>
            <div className="inner">
              <Content>
                <CSwiper
                  key={active}
                  ref={swiperRef}
                  list={list.length ? list : [{}]}
                  footerRender={(item) => {
                    if (item.id) {
                      return (
                        <CheckIcon>
                          {item.is_bind ? (
                            <img
                              src="/image/checked.png"
                              alt=""
                              onClick={() => {
                                // 解绑
                                sendShoesHandle("unbinding", {
                                  slot: active,
                                  id: item.id,
                                });
                              }}
                            />
                          ) : (
                            <Circle
                              onClick={async () => {
                                // 绑定
                                sendShoesHandle("binding", {
                                  slot: active,
                                  id: item.id,
                                });
                              }}
                            />
                          )}
                        </CheckIcon>
                      );
                    }
                  }}
                />
              </Content>
            </div>
          </Right>
        </Inner>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.div`
  height: 37.7rem;
  background: #f4f5f6;
  box-shadow: .0rem .0rem 2px rgba(0, 0, 0, 0.08);
  border-radius: 2.0rem;
  padding: 1.0rem 1.0rem 1.0rem .5rem;
  margin-top: 1.0rem;
`;

const Inner = styled.div`
  background: #ffffff;
  box-shadow: .0rem .0rem 2px rgba(0, 0, 0, 0.08);
  height: 100%;
  border-radius: 1.5rem;
  display: flex;
  overflow: hidden;
`;

const Left = styled.div`
  width: 10.0rem;
  background: #f4f5f6;

  text-align: center;
`;

const Right = styled.div`
  text-align: center;
  flex: 1;

  width: calc(100% - 7.3rem);
  background-color: #f4f5f6;
  .inner {
    background-color: #fff;
    border-radius: 1.0rem;
    border-top-left-radius: 0%;
    padding-bottom: 1.0rem;
    position: relative;
    height: 100%;
  }
`;

const Content = styled.div`
  width: 100%;
  .equips_img.active {
    width: 16.0rem;
    height: 16.0rem;
    padding-top: 1.5rem;
  }
  .equips_img {
    width: 12.0rem;
    height: 12.0rem;
  }
`;

const CheckIcon = styled.div`
  position: absolute;
  right: 1.0rem;
  top: 1.0rem;
  font-size: 1.8rem;
  img {
    width: 2.0rem;
    height: 2.0rem;
  }
`;
